
import { Vue, Options } from "vue-class-component";
import { openToast } from "toast-ts";

@Options({
  props: {
    toastShow: Boolean,
    count: Number
  },
  watch: {
    count(newVal, oldVal) {
      if (newVal != oldVal) {
        this.countIndex = newVal;
      }
    }
  }
})
export default class ValueAnimation extends Vue {
  touchUp = false;
  countIndex = 0;
  mounted() {
    const btn = document.getElementById("bttt") as HTMLButtonElement;
    btn.addEventListener("touchstart", () => {
      console.log("OnUp");
      this.touchUp = true;
    });
    btn.addEventListener("touchend", () => {
      // this.isShowControls = true;
      console.log("OnDown");
      this.touchUp = false;
    });
    btn.addEventListener("touchcancel", () => {
      // this.isShowControls = true;
      console.log("touchcancel");
      openToast("touchcancel");
    });
    btn.addEventListener("touchmove", () => {
      // this.isShowControls = true;
      console.log("touchmove");
      openToast("touchmove");
    });
  }

  onClick() {
    console.log();
  }
}
